import { ISOCurrencyCode } from '@xbcb/shared-types';

// Currency for US customs entries. US Consumption Entry charges are always
// reported to CBP in USD, so this is fixed for the US entry UI. Centralized
// here (rather than inline in utilities) to keep a single source of truth and
// avoid drift if additional entry countries are ever supported.
export const US_ENTRY_CURRENCY = ISOCurrencyCode.USD;
